<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-data-table
        :headers="headers"
        :items="all_new_clients"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status == 0
                ? { 'background-color': 'yellow' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right">{{ props.item.phone }}</td>
            <td class="text-xs-right">{{ props.item.address }}</td>
            <td class="text-xs-right">{{ props.item.mandob_sales }}</td>
            <td class="text-xs-right">{{ props.item.mandob_taworid }}</td>
            <td class="justify-center layout px-0">
              <v-dialog
                v-model="detail_dialog"
                width="800"
                dark
                style="padding:10px"
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    class="ml-4"
                    v-on="on"
                    @click="detailItem(props.item)"
                  >
                    book
                  </v-icon>
                </template>

                <v-card>
                  <v-card-title class="headline orange lighten-2" primary-title>
                    تفاصيل العميل الجديد
                  </v-card-title>

                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md4>
                        الاسم :
                        {{ item_detail.name }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        التليفون :
                        {{ item_detail.phone }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        الايميل :
                        {{ item_detail.email }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        الحد الائتماني :
                        {{ item_detail.had_eetmani }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        الرصيد الحالي :
                        {{ item_detail.rasid_efttahi }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        العنوان :
                        {{ item_detail.address }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        الموبايل :
                        {{ item_detail.mobile }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        الفاكس :
                        {{ item_detail.fax }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        المالك :
                        {{ item_detail.owner }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        المدير :
                        {{ item_detail.client_manger }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        طريقة الدفع :
                        {{ item_detail.pay_method }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        السجل الضريبي :
                        {{ item_detail.drayb_card_number }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        السجل التجاري :
                        {{ item_detail.commercial_card_number }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        نوع العميل :
                        {{ item_detail.client_type }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        الفرع :
                        {{ item_detail.branch }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        مندوب التوريد :
                        {{ item_detail.mandob_taworid }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        مندوب المبيعات :
                        {{ item_detail.mandob_sales }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        المحافظة :
                        {{ item_detail.mohafza }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        المدينة :
                        {{ item_detail.city }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        المنطقة :
                        {{ item_detail.region }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        تم الاضافة بواسطة :
                        {{
                          item_detail.user && item_detail.user.employer
                            ? item_detail.user.employer.name
                            : ""
                        }}
                      </v-flex>
                    </v-layout>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="detail_dialog = false">
                      موافق
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </td>
            <td style="padding:0px">
              <v-icon
                v-if="props.item.status == 0"
                @click="edit_new_item(props.item)"
              >
                edit
              </v-icon>
            </td>
            <td style="padding:0px">
              <v-btn
                :disabled="props.item.status == 1"
                small
                color="orange"
                style="margin:0px;padding:0px"
                @click.prevent="confirm_new_client(props.item)"
              >
                <!-- @click="confirm_fatwora" -->
                تم الاضافة ؟؟
              </v-btn>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>

    <v-dialog
      fullscreen
      v-model="add_dialog"
      max-width="500px"
      dir="rtl"
      align="right"
    >
      <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
      <v-card style="min-height: 44%;">
        <v-card-title class="headline orange lighten-2" primary-title>
          تفاصيل العميل الجديد
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4>
              الاسم :
              {{ item_detail.name }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              التليفون :
              {{ item_detail.phone }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              الايميل :
              {{ item_detail.email }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              الحد الائتماني :
              {{ item_detail.had_eetmani }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              الرصيد الحالي :
              {{ item_detail.rasid_efttahi }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              العنوان :
              {{ item_detail.address }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              الموبايل :
              {{ item_detail.mobile }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              الفاكس :
              {{ item_detail.fax }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              المالك :
              {{ item_detail.owner }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              المدير :
              {{ item_detail.client_manger }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              طريقة الدفع :
              {{ item_detail.pay_method }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              السجل الضريبي :
              {{ item_detail.drayb_card_number }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              السجل التجاري :
              {{ item_detail.commercial_card_number }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              نوع العميل :
              {{ item_detail.client_type }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              الفرع :
              {{ item_detail.branch }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              مندوب التوريد :
              {{ item_detail.mandob_taworid }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              مندوب المبيعات :
              {{ item_detail.mandob_sales }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              المحافظة :
              {{ item_detail.mohafza }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              المدينة :
              {{ item_detail.city }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              المنطقة :
              {{ item_detail.region }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              تم الاضافة بواسطة :
              {{
                item_detail.user && item_detail.user.employer
                  ? item_detail.user.employer.name
                  : ""
              }}
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>
      </v-card>

      <v-card>
        <v-card-title>
          <span class="headline">اضافة عميل</span>
          <v-divider class="mx-2" inset vertical></v-divider>

          <span
            >برجاء ادخال باقي الحقول او اختيارها بناءا علي البيانات الأعلي
          </span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md2>
                  <v-text-field
                    disabled
                    v-model="mycode"
                    label="كود العميل"
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.code')"
                    data-vv-name="code"
                    data-vv-scope="form1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-select
                    v-model="select_title"
                    :items="titles"
                    item-text="name"
                    item-value="id"
                    label="أختر اللقب"
                    persistent-hint
                    return-object
                    single-line
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    v-model="newItem.name"
                    label="أسم العميل"
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.name')"
                    data-vv-name="name"
                    data-vv-scope="form1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.phone"
                    label="تليفون العميل"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.email"
                    label="الايميل "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.had_eetmani"
                    label="حد ائتماني "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.rasid_efttahi"
                    label="رصيد افتتاحي "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.address"
                    label="العنوان بالتفصيل  "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.mobile"
                    label=" موبايل "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.fax"
                    label=" الفاكس "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.owner"
                    label=" صاحب المنشأة "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.client_manger"
                    label=" المدير المسئول "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.client_level"
                    label="درجة العميل  "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="select_pay_method"
                    :items="pay_operations"
                    item-text="name"
                    item-value="id"
                    label="  نوع التعامل"
                    persistent-hint
                    return-object
                    single-line
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.drayb_card_number"
                    label="رقم البطاقة الضريبية  "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.commercial_card_number"
                    label="رقم السجل التجاري  "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="newItem.clientbarcode"
                    label=" باركود "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="select_branch"
                    :items="branchs"
                    item-text="name"
                    item-value="id"
                    label="أختر الفرع"
                    persistent-hint
                    return-object
                    single-line
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.manger')"
                    data-vv-name="manger"
                    data-vv-scope="form1"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="select_mohafza"
                    :items="mohafzas"
                    item-text="name"
                    item-value="id"
                    label="أختر المحافظة"
                    persistent-hint
                    return-object
                    single-line
                    @change="getCities(select_mohafza.id)"
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.manger')"
                    data-vv-name="manger"
                    data-vv-scope="form1"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="select_city"
                    :items="cities"
                    item-text="name"
                    item-value="id"
                    label="أختر المدينة"
                    persistent-hint
                    return-object
                    single-line
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.manger')"
                    data-vv-name="manger"
                    data-vv-scope="form1"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="select_region"
                    :items="regions"
                    item-text="name"
                    item-value="id"
                    label="أختر المنطقة"
                    persistent-hint
                    return-object
                    single-line
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.manger')"
                    data-vv-name="manger"
                    data-vv-scope="form1"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="select_mandob_taworid"
                    :hint="
                      `${select_mandob_taworid.job_name}, ${
                        select_mandob_taworid.name
                      }`
                    "
                    :items="employers"
                    item-text="name"
                    item-value="id"
                    label="أختر مندوب التوريد"
                    persistent-hint
                    return-object
                    single-line
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.manger')"
                    data-vv-name="manger"
                    data-vv-scope="form1"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="select_mandob_sales"
                    :hint="
                      `${select_mandob_sales.job_name}, ${
                        select_mandob_sales.name
                      }`
                    "
                    :items="employers"
                    item-text="name"
                    item-value="id"
                    label="أختر مندوب المبيعات"
                    persistent-hint
                    return-object
                    single-line
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.manger')"
                    data-vv-name="manger"
                    data-vv-scope="form1"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save('form1')"
            >حفظ</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  log_me,
  cities,
  clients_page,
  new_clients,
  add_client,
  confirm_new_client
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    dialog: false,

    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    item_detail: {},
    detail_dialog: false,

    select_sadad_type: { id: "", job_name: "", name: "أختر نوع السداد" },
    select_client: { id: "", job_name: "", name: "أختر المورد" },
    select_employer: { id: "", job_name: "", name: "أختر المسئول" },
    select_store: { id: "", job_name: "", name: "أختر المخزن" },
    select_item: { id: "", job_name: "", name: "أختر الصنف" },
    select_sadadstatuses: { name: "" },

    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      {
        text: "الاسم ",
        align: "right",
        value: "name"
      },
      { text: "التليفون ", value: "phone", align: "right" },
      { text: " العنوان", value: "address", align: "right" },
      { text: " مندوب المبيعات", value: "mandob_sales", align: "right" },
      { text: " مندوب التوريد", value: "mandob_taworid", align: "right" },
      { text: " تفاصيل", value: "store", sortable: false, align: "right" },
      { text: "تعديل", value: "store", sortable: false, align: "right" },
      { text: " تم الاضافة", value: "store", sortable: false, align: "right" }
    ],
    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "client_name", sortable: false, align: "right" },
      {
        text: " العدد النهائي",
        value: "item_num_after",
        sortable: false,
        align: "right"
      },
      {
        text: "   البونص",
        value: "item_bonus",
        sortable: false,
        align: "right"
      }
    ],

    fatworas: [],
    m_sadad_types: [],
    m_employers: [],
    clients: [],
    all_new_clients: [],
    m_items: [],
    stores: [],
    client_search_name: "",
    sadadstatuses: [],
    newItem: {
      code: "",
      name: "",
      phone: "",
      email: "",
      had_eetmani: "",
      rasid_efttahi: "",
      branch_id: "",
      mandob_taworid_id: "",
      mandob_sales_id: "",
      address: "",
      mobile: "",
      fax: "",
      owner: "",
      client_manger: "",
      client_level: "",
      pay_method: "",
      drayb_card_number: "",
      commercial_card_number: "",
      clientbarcode: "",
      client_type_id: "",
      mohafza_id: "",
      region_id: "",
      city_id: ""
    },
    madionia: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "",
      emp_id: ""
    },
    added_items: [],
    madionia_sabqa_of_madionia: "",
    branchs: [],
    employers: [],
    titles: [],
    mohafzas: [],
    regions: [],
    cities: [],
    pay_operations: [],
    select_branch: { id: "" },
    select_mandob_taworid: { id: "" },
    select_mandob_sales: { id: "" },
    select_mohafza: { id: "" },
    select_region: { id: "" },
    select_city: { id: "" },
    select_title: { id: "" },
    select_pay_method: { id: "", name: "" },
    pay_operations: [
      { id: 1, name: "نقدي" },
      { id: 2, name: "أجل" },
      { id: 3, name: "شيكات" }
    ]
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    mycode() {
      if (this.clients.length > 0) {
        return (this.code =
          parseInt(this.clients[this.clients.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    // this.initialize()
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();

    clients_page().then(response => {
      this.clients = response.data.clients;
      this.branchs = response.data.branches;
      this.employers = response.data.employers;
      this.titles = response.data.client_types;
      this.mohafzas = response.data.mohafzas;
      this.regions = response.data.regions;
    });

    new_clients().then(res => {
      this.all_new_clients = res.data;
      this.pagination.totalItems = res.data.length;
      this.loading = false;
    });
  },

  methods: {
    initialize() {},
    getCities(id) {
      cities(id).then(response => {
        this.cities = response.data;
      });
    },

    edit_new_item(item) {
      this.newItem.code = item.code;
      this.newItem.name = item.name;
      this.newItem.phone = item.phone;
      this.newItem.email = item.email;
      this.newItem.had_eetmani = item.had_eetmani;
      this.newItem.rasid_efttahi = item.rasid_efttahi;
      this.newItem.mandob_taworid_id = item.mandob_taworid_id;
      this.newItem.mandob_sales_id = item.mandob_sales_id;
      this.newItem.address = item.address;
      this.newItem.mobile = item.mobile;
      this.newItem.fax = item.fax;
      this.newItem.owner = item.owner;
      this.newItem.client_manger = item.client_manger;
      this.newItem.client_level = item.client_level;
      this.newItem.pay_method = item.pay_method;
      this.newItem.drayb_card_number = item.drayb_card_number;
      this.newItem.commercial_card_number = item.commercial_card_number;
      this.newItem.clientbarcode = item.clientbarcode;
      this.add_dialog = true;
      this.item_detail = item;
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (
          valid &&
          this.select_mandob_taworid.id != "" &&
          this.select_mandob_sales.id != "" &&
          this.select_title.id != "" &&
          this.select_pay_method.id != "" &&
          this.select_mohafza.id != "" &&
          this.select_region.id != "" &&
          this.select_city.id != ""
        ) {
          this.loading = true;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.newItem.code = this.code;
          this.newItem.branch_id = this.select_branch.id;
          this.newItem.mandob_taworid_id = this.select_mandob_taworid.id;
          this.newItem.mandob_sales_id = this.select_mandob_sales.id;
          this.newItem.name = this.select_title.name
            ? this.select_title.name + " " + this.newItem.name
            : this.newItem.name;
          this.newItem.client_type_id = this.select_title.id;
          this.newItem.pay_method = this.select_pay_method.name;
          this.newItem.pay_method_id = this.select_pay_method.id;
          this.newItem.mohafza_id = this.select_mohafza.id;
          this.newItem.region_id = this.select_region.id;
          this.newItem.city_id = this.select_city.id;

          this.madionia.madionia_before = 0;
          this.madionia.cost_or_money = this.newItem.rasid_efttahi;
          this.madionia.madionia_after = this.newItem.rasid_efttahi;
          this.madionia.emp_name = myUser.name;
          this.madionia.type_of_operation = "efftahi";
          this.madionia.code_of_operation = this.newItem.code;
          this.madionia.emp_id = myUser.id;
          var frmData = new FormData();
          frmData.append("client", JSON.stringify(this.newItem));
          frmData.append("madionia", JSON.stringify(this.madionia));

          add_client(frmData).then(response => {
            this.loading = false;
            this.confirm_new_client(this.item_detail);
            this.clients.push(response.data);
            this.close();
            var frmData3 = new FormData();
            frmData3.append("title", "اضافة عميل جديد");
            frmData3.append(
              "body",
              "تم اضافة عميل جديد بإسم " +
                this.newItem.name +
                " وكود " +
                this.newItem.code +
                " فرع " +
                this.select_branch.name +
                " بواسطة " +
                myUser.name
            );
            frmData3.append("type", "new_client");
            frmData3.append("user_id", myUser.id);
            log_me(frmData3).then(response => {
              if (response.data == true) {
                let mytitle = "اضافة عميل جديد";
                let mybody =
                  "تم اضافة عميل جديد بإسم " +
                  this.newItem.name +
                  " وكود " +
                  this.newItem.code +
                  " فرع " +
                  this.select_branch.name +
                  " بواسطة " +
                  myUser.name;
                this.$toastr.warning(mybody, mytitle, {
                  closeButton: true,
                  progressBar: true,
                  positionClass: "toast-bottom-left",
                  preventDuplicates: false,
                  timeOut: "25000"
                });
              }
            });
            this.$router.go(0);
          });
        }
      });
    },

    confirm_new_client(item) {
      let myUser = JSON.parse(localStorage.getItem("user"));
      this.loading = true;
      confirm_new_client(item.id).then(response => {
        this.loading = false;
        const index = this.fatworas.indexOf(item);
        this.fatworas.splice(index, 1);
        let myUser = JSON.parse(localStorage.getItem("user"));
        var frmData3 = new FormData();
        frmData3.append("title", "التاكيد علي اضافة عميل جديد");
        frmData3.append(
          "body",
          "تم التاكيد علي اضافة عميل جديد " +
            item.name +
            "منطقة " +
            item.region +
            " بواسطة " +
            myUser.name
        );
        frmData3.append("type", "confirm_new_client");
        frmData3.append("user_id", myUser.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = "التاكيد علي اضافة عميل جديد";
            let mybody =
              "تم التاكيد علي اضافة عميل جديد  " +
              item.name +
              "منطقة " +
              item.region +
              " بواسطة " +
              myUser.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
          }
        });
      });
    },

    detailItem(order) {
      this.item_detail = order;
    }
  }
};
</script>

<style scope>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
</style>
